import { I18n } from '@calendly/i18n'
import { SimplePopup } from '@calendly/ui/components/popup'

import { BRAND_REFRESH_OPT_IN_SOURCES } from './constants'
import { useOptInToBrandRefresh } from './useOptInToBrandRefresh'

interface BrandRefreshTryConfirmModalProps {
  onClose: () => void
}

export const BrandRefreshTryConfirmModal = ({ onClose }: BrandRefreshTryConfirmModalProps) => {
  const { optIn, isLoading } = useOptInToBrandRefresh()

  return (
    <SimplePopup
      isOpen
      isLoading={isLoading}
      onClose={onClose}
      onConfirm={() => optIn(BRAND_REFRESH_OPT_IN_SOURCES.TRY_CONFIRM)}
      title={I18n.t('publisher.app_shell.brand_refresh_beta.try_confirm.title')}
      cancelLabel={I18n.t('publisher.app_shell.brand_refresh_beta.try_confirm.wait')}
      confirmLabel={I18n.t('publisher.app_shell.brand_refresh_beta.try_confirm.switch_now')}
    >
      {I18n.t('publisher.app_shell.brand_refresh_beta.try_confirm.body')}
    </SimplePopup>
  )
}
